<template>
  <LayoutMain @toTop="scrollToTop">
    <vueScroll v-show="matList.length" ref="vs" @handle-scroll="handleScroll">
      <div class="home_list">
        <ColItem
          v-for="item in matList" :key="item.id"
          v-report:mainclick="{ area: 'content', pos: 0 }"
          :item="item"
          class="home_item"
          :numberCol="numberCol"
          :type="colItemType"
          @click.native="clickDownload(item)">
          <template v-slot:center>
            <div class="download">
              <span>预览并下载</span>
              <em class="right_arrow" />
            </div>
          </template>
          <template v-slot:topRight>
            <div
              :class="['item_collect', { is_collect: isCollect(item.id) }]"
              @click.stop="changeCollect(item.id)" />
          </template>
        </ColItem>
      </div>

      <!-- 翻页，置顶功能 -->
      <TurnPage
        class="home_turn_page" :toTopVisible="true" :hasBefore="false" :hasNext="false"
        @toTop="toTopHandle" />
    </vueScroll>
    <div v-show="!matList.length" class="no_data">
      <p class="font">没有找到相关内容，换个词试试</p>
    </div>
  </LayoutMain>
</template>

<script>
import LayoutMain from '@/components/Layout/LayoutMain.vue'
import ColItem from '@/components/ItemLayout/ColItem.vue'
import TurnPage from '@/components/TurnPage/index.vue'
import { RetCode, limitCode, limitCodeByPay } from '@/api/bussinessCode.js'
import {
  scrollRateFast, itemLayoutType, actionOpenTableType,
  tableKey
} from '@/common/const.js'
import {
  CacheSessionGetSource, CacheIsNewUser, CacheSetMatInfo,
  CacheSessionGetProjectType
} from '@/common/cache.js'
import { parseURL } from '@/common/utils.js'
import {
  ClientGetUserInfo, ClientDownload,
  ClientGetIsVip, ClientOpenResource,
  ClientGetVersion, ClientOpenTabsMatDetail,
  ClientOpenTabsMatDetailMini, ClientSendMsgToTable
} from '@/api/clientApi.js'
import api from '@/api'
import { report } from '@/report/index.js'
import { updatePrivliege, openBuyDialogByAbTest, openLoginDialogByAbTest } from '@/common/business.js'

export default {
  name: 'Home',

  components: { LayoutMain, ColItem, TurnPage },

  data () {
    return {
      isDownloading: false,
      canOpenMatDetail: false,
    }
  },

  computed: {
    isTestMidAutumn () {
      return this.$store.getters['abTest/isTestMidAutumn']
    },

    actionOpenTable () {
      return this.$store.state.actionOpenTable
    },

    matList () {
      return this.$store.state.home.homeRes.list
    },

    collectIdList () {
      return this.$store.state.home.collectIdList
    },

    count () {
      return this.$store.state.home.homeRes.count
    },

    pageSize () {
      return this.$store.state.home.home.size
    },

    page () {
      return this.$store.state.home.home.page
    },

    activeIndex () {
      return this.$store.state.activeIndex
    },

    asideArr () {
      return this.$store.state.home.asideArr
    },

    hasNext () {
      return this.$store.state.home.hasNext
    },

    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    },

    isVipForever () {
      return this.$store.getters.isVipForever
    },

    numberCol () {
      return this.$store.state.home.numberCol
    },

    projectType () {
      return this.$store.state.projectType
    },
    colItemType () {
      const map = {
        ppt: itemLayoutType.horizontal,
        excel: itemLayoutType.vertical,
        word: itemLayoutType.vertical
      }

      const projectType = CacheSessionGetProjectType()
      return map[projectType]
    }
  },

  created () {
    this.reportOpen()

    this.setCanOpenMatDetail()

    this.setListenDownloading()

    // 子页面关闭，通知父页面，不建议扔app.vue，父子页面都会触发
    window.sendSubTabCloseMsg = (params) => {
      params = JSON.parse(params)
      ClientGetUserInfo((userInfo) => {
        this.$store.commit('vuexSetUserInfo', userInfo)
        this.toastActivityNoNeed(params)
        if (this.isLoginedIn) {
          this.$store.dispatch('home/vuexGetUserCollectIdList') // 获取用户收藏模板id列表
          // 刷新主页列表
          this.scrollToTop()
          this.$store.commit('home/vuexResetHomeRes')
          this.$store.commit('home/vuexResetHomePage')
          this.$store.dispatch('home/vuexGetMatList')
        }
      }, () => {
        this.$toast({ desc: '获取用户信息失败，请联系客服！' })
      })
    }

    // 下载是异步线程，所以成功给回调
    window.sendDownloadMsg = (res1) => {
      this.$store.commit('vuexChangeLoading', false)
      this.$store.commit('vuexChangeDownloadStatus', false) // 取消下载也会触发下载失败
      this.isDownloading = false

      const res = JSON.parse(res1) // 没有经历封装，所以得parse以下

      if (res.cancel) {
        // 上报，用户取消下载
        report('download', { goodsid: res.id, classid: '', setp: '6', ext: '' })
        return
      }

      if (!res.downloadok) {
        // 上报，客户端下载失败
        report('download', { goodsid: res.id, classid: '', setp: '4', ext: '' })

        this.$toast({ desc: `下载失败，请联系重试或者联系客服，素材id：${res.id}` })
      }
    }
  },

  methods: {
    changeCollect (matId) {
      report('mainclick', { area: 'content', pos: 1 })
      if (this.collectIdList.includes(matId)) {
        this.$store.dispatch('home/vuexRemoveCollectId', matId)
      } else {
        this.$store.dispatch('home/vuexAddCollectId', matId)
      }
    },

    toastActivityNoNeed (tableCloseParmas) {
      const { name: nameClose } = tableCloseParmas
      // 不是测试中秋活动或者关闭的不是loginTableNew不处理

      if (!this.isTestMidAutumn || nameClose !== tableKey.loginTableNew) {
        return
      }
      // 唤起弹窗唤起类型是否为点击活动入口唤起的
      const isClickActivity = this.actionOpenTable === actionOpenTableType.clickActivity

      if (isClickActivity && this.isVipForever) {
        this.$toast({ desc: '您已是终身会员，不需参加该活动' })
      }

      // 还原唤起类型为默认状态
      this.$store.commit('vuexChangeActionOpenTable', actionOpenTableType.default)
    },

    isCollect (matId) {
      return this.collectIdList.includes(matId)
    },

    reportOpen () {
      ClientGetIsVip((res) => {
        const dubaVip = res?.result || false

        report('open', { ptype: 1, isnew: CacheIsNewUser() ? '1' : '2', isdbvip: dubaVip ? '1' : '2' })
      })
    },

    scrollToTop () {
      this.$refs.vs.scrollTo({ y: 0 }, scrollRateFast * this.page)
    },

    toTopHandle () {
      report('mainclick', { area: 'turn', pos: 0 })

      this.scrollToTop()
    },

    next () { this.targetPage(this.page + 1) },

    targetPage (page) {
      this.$store.dispatch('home/vuexChangeHomeParames', { page })
    },

    handleScroll (v) { // 记录滚动的位置, handle-scroll-complete不生效，到时候可以优化
      if (this._timer) { clearTimeout(this._timer) } // 防止滚动事件调用多次接口

      const hasNext = this.count > this.page * this.pageSize
      if (!hasNext) { return }

      this._timer = setTimeout(() => {
        clearTimeout(this._timer)
        if (v.process > 0.95) {
          this.next()
        }
      }, 200)
    },

    cutSuffix (url) {
      const lastUrl = parseURL(url).file
      return lastUrl.slice(lastUrl.indexOf('.'))
    },

    // 由于需要兼容客户端旧版本，和MatDetailDialog那边共存两套逻辑一样的下载代码
    // 后期建议考虑如何复用，改动需要两边一起同步
    clickDownload (item) {
      if (this.isDownloading) {
        ClientSendMsgToTable('matDetail', 'showToastDownloading')
        return
      }
      // 上报，打开文件
      report('download', { goodsid: item.id, classid: item.class_id, setp: '7', ext: '' })
      ClientOpenResource(item.id + '')
        .catch(() => {
          if (!this.isLoginedIn) {
            openLoginDialogByAbTest(this.$store)
            return
          }

          if (this.canOpenMatDetail) {
            this.setCacheMatInfo(item)
            this.openMatDetailByVersion()
            return
          }

          if (!this.isLoginedIn) {
            openLoginDialogByAbTest(this.$store)
            return
          }

          this.apixDownLoad(item)
        })
    },

    apixDownLoad (item) {
      updatePrivliege(this.$store).finally(() => {
        api.material.download({ data: { mat_id: item.id, source: CacheSessionGetSource() || '' } }).then(res => {
          const url = res?.data?.url
          if (url) {
            this.clientDownload({ classId: item.class_id, matId: item.id, url, name: item.name })
            return
          }
          this.$toast({ desc: '获取链接失败，请联系客服' })
        }).catch(data => {
          const code = String(data?.ret || '')

          if (code === limitCodeByPay) {
            // 上报，服务端非会员限制
            report('download', { goodsid: item.id, classid: item.class_id, setp: '1', ext: '' })
            openBuyDialogByAbTest(this.$store)
            return
          }

          if (code === limitCode) {
            // 上报，服务端下载次数限制
            report('download', { goodsid: item.id, classid: item.class_id, setp: '2', ext: '' })

            this.$store.commit('tipsDialog/vuexChangeUpdateVipLevelDialog', true)
            return
          }

          if (RetCode?.[code]) {
            // 上报，其他服务端下载错误
            report('download', { goodsid: item.id, classid: item.class_id, setp: '3', ext: '' })

            this.$toast({ desc: RetCode[data.ret] })
          }
        })
      })
    },

    clientDownload (params) {
      const { classId, matId, name, url } = params
      const downType = this.asideArr[this.activeIndex].downType
      const req = { id: matId + '', fileName: name + this.cutSuffix(url), type: downType, url }
      ClientDownload(req)
        .then(res => {
          if (!res.result) {
            this.$toast({ desc: '客户端下载调用失败，请重试或联系客服' })
            return
          }
          this.$store.commit('vuexChangeLoading', true)
          this.$store.commit('vuexChangeDownloadStatus', true)
        })
        .catch(() => {
          // 上报，客户端下载失败
          report('download', { goodsid: matId, classid: classId, setp: '5', ext: '' })

          this.$toast({ desc: '下载失败，请重试或联系客服！' })
          this.$store.commit('vuexChangeLoading', false)
        })
    },

    setCanOpenMatDetail () {
      ClientGetVersion(() => {
        this.canOpenMatDetail = true
      }, () => {
        this.canOpenMatDetail = false
      })
    },

    setCacheMatInfo (item) {
      const { id, name, class_id: classId } = item
      const downType = this.asideArr[this.activeIndex].downType
      const matInfo = { id, name, classId, downType }
      CacheSetMatInfo(matInfo)
    },

    setListenDownloading () {
      window.sendMsgToWeb = (res) => {
        if (res === 'isDownloading') {
          this.isDownloading = true
        }
      }
    },

    openMatDetailByVersion () {
      ClientGetVersion((version) => {
        // version为2的时候支持office打开大弹窗不遮挡
        if (version >= 2) {
          ClientOpenTabsMatDetail()
        } else {
          ClientOpenTabsMatDetailMini()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home_list { padding: 8px 6px;
  &.is_element { padding: 8px 16px; }
  .home_item { margin: 8px 10px; cursor: pointer; }
  .download { display: flex; align-items: center; font-size: 18px; color: #FFFFFF;
    .right_arrow { width: 7px; height: 7px; margin-left: 3px; border-top: 1px solid #FFFFFF; border-right: 1px solid #FFFFFF; writing-mode: tb-rl; -ms-transform: rotate(45deg); transform: rotate(45deg); }
  }
  .item_collect { width: 24px; height: 24px; background-image: url(~@/assets/images/icon_collect.png);
    &.is_collect { background-position: right; }
  }
}
.home_turn_page { position: fixed; bottom: 40px; left: 450px; z-index: 10; }
.no_data { position: absolute; top: 50%; left: 50%; width: 256px; height: 211px; text-align: center; background: url(~@/assets/images/bg_no_data.png) center center no-repeat; background-size: 100% 100%; transform: translate(-50%, -50%);
  .font { margin-top: 135px; font-size: 16px; color: #AFB0C0; }
}
</style>
